import { axiosClient } from './request';

const groupServices = {
  create(body) {
    return axiosClient.post('/groups', body);
  },
  list({
    pageSize = 20,
    pageIndex = 0,
    sort_by = [],
    globalFilter = '',
    dates = [null, null],
    moreFilterData = {}
  } = {}) {
    return axiosClient.get('/groups', {
      params: {
        sort_by,
        limit: pageSize,
        page: pageIndex + 1,
        group_name: globalFilter,
        start_date: dates[0],
        end_date: dates[1],
        ...moreFilterData
      }
    });
  },
  updateGroup(id, body) {
    return axiosClient.put(`groups/${id}`, body);
  },
  detail(id) {
    return axiosClient.get(`/groups/${id}`);
  },
  deleteGroupSupervisor(userId, supervisorId) {
    return axiosClient.delete(`groups/${userId}/users/${supervisorId}`);
  },
  getGroupSupervisors(id) {
    return axiosClient.get(`/groups/${id}/supervisors`);
  },
  getListAvailableToSupervisor(id, params) {
    return axiosClient.get(`/groups/${id}/assign-users`, { params });
  },
  assignToGroupSupervisor(id, uid) {
    return axiosClient.post(`groups/${id}/users/${uid}`);
  },
  connectStripe(groupId) {
    return axiosClient.post(`groups/${groupId}/invite`);
  },
  getAvailablePrincipal(groupId, params) {
    return axiosClient.get(`groups/${groupId}/principals`, { params });
  },
  listGroupChargeType() {
    return axiosClient.get(`/groups/charge-types`);
  },
  listPlatformAgreementType() {
    return axiosClient.get(`/groups/agreement-types`);
  },
  listGroupAccountType() {
    return axiosClient.get(`/groups/account-types`);
  },
  listGroupInstantPayoutType() {
    return axiosClient.get(`/groups/instant-payout-types`);
  }
};

export default groupServices;
